import { put, takeEvery } from 'redux-saga/effects'
import { MEMBERSHIP_USERDEFINEDFIELDS_LOADING, MEMBERSHIP_USERDEFINEDFIELDS_DATA_SUCCESS, MEMBERSHIP_USERDEFINEDFIELDS_DATA_ERROR } from "../actions/actionMembershipUserDefinedFeilds";
import { apiUserDefinedFields } from 'api';

async function fetchAsync(func, payload) {
    const response = await func(payload);
    if (response.status == 200) {
        return await response.json();
    }
    else if (response.status == 202 || response.status == 204) {
        return "nocontent";
    }
    if (response.status == 400) {
        let error = await response.json();
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Errors[0].ErrorMessage.replace('Error: ', '') + " response status: " + response.status + "\"}]}")
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get memberships user defined fields, response status: " + response.status + "\"}]}")
    }
}

function* GetMembershipsUserDefinedFields(action) {
    try {
        let udfsresponse = yield fetchAsync(apiUserDefinedFields, action);
        yield put({ type: MEMBERSHIP_USERDEFINEDFIELDS_DATA_SUCCESS, payload: udfsresponse });
    } catch (e) {
        yield put({ type: MEMBERSHIP_USERDEFINEDFIELDS_DATA_ERROR, error: e.Errors[0].ErrorMessage });
    }
}

export const sagaMembershipUserDefinedFields = [
    takeEvery(MEMBERSHIP_USERDEFINEDFIELDS_LOADING, GetMembershipsUserDefinedFields),
];
